import { Directive, HostListener, inject } from '@angular/core';
import { NavigationService } from '../services/navigation.service';

@Directive({
  selector: 'a[navigateBack], button[navigateBack]',
  standalone: false,
})
export class NavigateBackDirective {
  private locationService = inject(NavigationService);

  @HostListener('click') onClick() {
    this.locationService.back();
  }
}
